import { render } from "./ClassStudents.vue?vue&type=template&id=34c38fdc&scoped=true"
import script from "./ClassStudents.vue?vue&type=script&lang=js"
export * from "./ClassStudents.vue?vue&type=script&lang=js"

import "./ClassStudents.vue?vue&type=style&index=0&id=34c38fdc&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c38fdc"]])

export default __exports__